import EmbedVersions from './EmbedVersions';
export default {
  [EmbedVersions.V3]: 1,
  [EmbedVersions.V4]: 2
};